import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SUPER_ADMIN_BUSINESS_INFORMATION_INPUTS,
} from '../../constants/new-application/business-information';
import { FormInput } from '../merchants/FormInput';
import { InputType } from '../form/form-input-constants';
import {
  FORM_FIELDS,
  FORM_FIELDS_NAMES,
  IApplicationDetails,
} from '../../constants/new-application/new-application-form';
import PCICheckbox from './PCICheckbox';
import LogoPreview from './LogoPreview';
import { FormikProps } from 'formik';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { UploadLogo } from '../developers/widget-configuration/UploadLogo';
import { FormCheckbox } from './FormCheckbox';
import { SectionWrapper } from '../SectionWrapper';
import { BUSINESS_FORM_FIELDS } from '../../constants/merchant/business-form';

interface Props {
  formik: FormikProps<IApplicationDetails>;
  formEditStatus: boolean;
  onSelectFile: (e) => void;
  setCreateNew: Dispatch<React.SetStateAction<boolean>>;
  onEditFile: () => void;
  onDeleteFile: () => void;
  uploadedFile: string | undefined;
  isDisable: boolean;
}

const BusinessInformationCard = (props: Props): React.ReactElement => {
  const {
    formik,
    formEditStatus,
    onSelectFile,
    setCreateNew,
    uploadedFile,
    isDisable,
    onEditFile,
    onDeleteFile

  } = props;
  const { t } = useTranslation();
  const { merchantState } = useMerchants();
  const {
    merchantsLists: lists,
    mccList,
  } = merchantState;



  const INPUTS = SUPER_ADMIN_BUSINESS_INFORMATION_INPUTS({ t, mccList, lists });

  return (
   <SectionWrapper
     title={t('NEW_APPLICATION.BUSINESS_INFORMATION')}
     pageLoading={false}
     isCardBody
     sectionAdditionalClass="mb-10"
   >
      <div className="row">
        {
          INPUTS.map(item => {
            return (
              <FormInput
                {...item}
                formik={formik}
                isEditMode={formEditStatus}
                key={item.key}
                setCreateNew={setCreateNew}
              />
            );
          })
        }

        {/*<FormInput*/}
        {/*  formik={formik}*/}
        {/*  key={FORM_FIELDS.WEB_URL}*/}
        {/*  fieldName={FORM_FIELDS.WEB_URL}*/}
        {/*  label={t(FORM_FIELDS_NAMES.WEB_URL)}*/}
        {/*  placeholder={`${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.WEB_URL)}`}*/}
        {/*  inputType={InputType.Website}*/}
        {/*  isLabelIcon={false}*/}
        {/*  tooltipText={String(formik.values?.[FORM_FIELDS.WEB_URL])}*/}
        {/*  isEditMode={formEditStatus}*/}
        {/*  // additionalClasses="col-12 col-md-6"*/}
        {/*/>*/}
        <FormCheckbox
          disabled={!formEditStatus}
          formik={formik}
          fieldName={FORM_FIELDS.SITE_VERIFICATION}
          label={FORM_FIELDS_NAMES.SITE_VERIFICATION}
          additionalClasses="mt-7"
        />

        <PCICheckbox
            formEditStatus={formEditStatus}
            formik={formik}
        />




      </div>
     <div className="row">
       <FormInput
           formik={formik}
           key={FORM_FIELDS.DESCRIPTION}
           fieldName={FORM_FIELDS.DESCRIPTION}
           label={t(FORM_FIELDS_NAMES.DESCRIPTION)}
           placeholder={t('NEW_APPLICATION.DESCRIPTION_PLACEHOLDER')}
           inputType={InputType.Description}
           isEditMode={formEditStatus}
           additionalClasses="col-12 col-md-6"
       />
       {
         formEditStatus
             ? (
                 <UploadLogo
                     uploadedFile={uploadedFile}
                     formik={formik}
                     isDisable={isDisable}
                     onDeleteFile={onDeleteFile}
                     onSelectFile={onSelectFile}
                     onEditFile={onEditFile}
                     isAdmin={true}
                     label={t(FORM_FIELDS_NAMES.LOGO)}
                     fieldName={FORM_FIELDS.LOGO}
                     additionalClass="col-6 col-sm-4 col-md-3"
                     imageAdditionalClass="download-file-logo"
                 />
             )
             : (
                 <LogoPreview
                     uploadedFile={uploadedFile}
                     label={t(FORM_FIELDS_NAMES.LOGO)}
                 />
             )
       }
     </div>
   </SectionWrapper>
  );
};

export default BusinessInformationCard;
